export const Index = r => require.ensure([], () => r(require('./index')), 'robots-bundle');

export default [
  {
    path: 'robots',
    name: 'robots',
    component: Index
  }
];
